var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCopySuccessIcon = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  width: "80%",
  height: "80%",
  viewBox: "0 0 50 50",
  enableBackground: "new 0 0 50 50",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 25,
  cy: 25,
  r: 25,
  fill: "#25ae88"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M38 15 22 33l-10-8",
  fill: "none",
  stroke: "#fff",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCopySuccessIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/copy_success_icon.543b28f9ab3f348216563977aab6ff73.svg";